var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _class, _class2, _descriptor, _descriptor2;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

/*!
 * @copyright
 * Copyright(c) 2021 SICK AG
 */
import { Component, Event, html, Prop } from '@sick-davinci/ce-decorators';
import { AbstractSlider } from '../slider/AbstractSlider';
import { style } from '../slider/Slider.style';
/**
 * A `davinci-flexi-slider` can be used to choose a value from a predefined set of values displayed in a legend.
 *
 * @example
 * ```html
 * <davinci-flexi-slider icon-left="av/volume_mute" value="3" value-set="[0,3,7,15,31,63]" icon-right="av/volume_up" style="margin-top: 2rem"></davinci-slider>
 * ```
 */

export let FlexiSlider = (_dec = Component({
  tag: 'davinci-flexi-slider',
  style,
  dependencies: [AbstractSlider]
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", Object), _dec4 = Prop({
  reflectAsAttribute: true
}), _dec5 = Reflect.metadata("design:type", Number), _dec6 = Prop({
  reflectAsAttribute: true
}), _dec7 = Reflect.metadata("design:type", Number), _dec8 = Prop({
  reflectAsAttribute: true
}), _dec9 = Reflect.metadata("design:type", Number), _dec10 = Event(), _dec11 = Reflect.metadata("design:type", Object), _dec12 = Event(), _dec13 = Reflect.metadata("design:type", Object), _dec(_class = (_class2 = class FlexiSlider extends AbstractSlider {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "_valueSet", [0, 1, 2, 3]);

    _defineProperty(this, "_maxIsUndefined", true);

    _defineProperty(this, "_minIsUndefined", true);

    _initializerDefineProperty(this, "change", _descriptor, this);

    _initializerDefineProperty(this, "input", _descriptor2, this);

    _defineProperty(this, "keyDownEvent", event => {
      if (this.KEY_CODE_ARROW_UP.includes(event.key) || this.KEY_CODE_ARROW_RIGHT.includes(event.key)) {
        this.updateValueAndEmit(this.increment(), true, false);
        event.preventDefault();
      } else if (this.KEY_CODE_ARROW_DOWN.includes(event.key) || this.KEY_CODE_ARROW_LEFT.includes(event.key)) {
        this.updateValueAndEmit(this.decrement(), true, false);
        event.preventDefault();
      }
    });

    _defineProperty(this, "_keyUpEvent", event => {
      if (this.KEY_CODE_ARROW_UP.includes(event.key) || this.KEY_CODE_ARROW_RIGHT.includes(event.key) || this.KEY_CODE_ARROW_DOWN.includes(event.key) || this.KEY_CODE_ARROW_LEFT.includes(event.key)) {
        this.updateValueAndEmit(this._value[0], false, true);
        event.preventDefault();
      }
    });

    _defineProperty(this, "_valueHasChanged", false);
  }

  /**
   * Possible values of the slider displayed in the legend
   */
  set valueSet(value) {
    this._valueSet = value;
    this.updateState();
  }

  get valueSet() {
    return this._valueSet;
  }

  _isValueSetEmpty() {
    return this._valueSet.length === 0;
  }
  /**
   * Current value of the slider.
   */


  set value(val) {
    this._value[0] = val;
    this.updateState();
  }

  get value() {
    return this._value[0];
  }

  /**
   * Current max value of the slider
   * @override
   */
  set max(val) {
    this._maxIsUndefined = false;
    super.max = val;
  }
  /**
   * @override
   */


  get max() {
    const userDefinedMax = super.max;

    if (this._isValueSetEmpty()) {
      // if there are no values take the max defined by the user (via the max-attribute)
      return userDefinedMax;
    }

    const valueSetMax = this._valueSet[this._valueSet.length - 1];

    if (this._maxIsUndefined || valueSetMax <= userDefinedMax) {
      // the greatest value of the value-set does not violate the user-defined max -> take it
      return valueSetMax;
    }

    return this._findClosestValue(userDefinedMax);
  }

  /**
   * Current min value of the slider
   */
  set min(val) {
    this._minIsUndefined = false;
    super.min = val;
  }
  /**
   * @override
   */


  get min() {
    const userDefinedMin = super.min;

    if (this._isValueSetEmpty()) {
      // if there are no values take the min defined by the user (via the min-attribute)
      return userDefinedMin;
    }

    const valueSetMin = this._valueSet[0];

    if (this._minIsUndefined || valueSetMin >= userDefinedMin) {
      // the smallest value of the value-set does not violate the user-defined min -> take it
      return valueSetMin;
    }

    return this._findClosestValue(userDefinedMin);
  }
  /**
   * Emitted [Number] if the value changes.
   */


  // ToDo @6.0.0 -> remove method and use onNumericFieldChange() directly

  /**
   * @override
   */
  synchronizeValueFieldValue(index, _initialValue, newValue) {
    this.onNumericFieldChange(newValue[index]);
  }

  onNumericFieldChange(newValue, index = 0) {
    if (this.value === newValue) {
      this.overwriteInputFieldValue(index, newValue);
    } else {
      this.value = newValue;
      this.change.emit(this.value);
    }
  }

  componentConnected() {
    this.legend = true;

    if (isNaN(this.value) || this.value === undefined) {
      this.value = 0;
    }

    super.componentConnected();
    this.addEventListener('keyup', this._keyUpEvent);
  }

  componentDisconnected() {
    super.componentDisconnected();
    this.removeEventListener('keyup', this._keyUpEvent);
  }
  /**
   * @override
   */


  increment() {
    const index = this._valueSet.indexOf(this.value);

    if (index === -1) {
      // the current value is not present in the valueSet so we start with the min value
      return this.min;
    }

    return this._valueSet[this._roundIndexWithTicks(index + Math.max(1, this.ticks))];
  }
  /**
   * @override
   */


  decrement() {
    const index = this._valueSet.indexOf(this.value);

    if (index === -1) {
      // the current value is not present in the valueSet so we start with the max value
      return this.max;
    }

    return this._valueSet[this._roundIndexWithTicks(index - Math.max(1, this.ticks))];
  }
  /**
   * @override
   */


  /**
   * @override
   */
  calcValueFrom(positionX) {
    if (this._isValueSetEmpty()) {
      return 0;
    }

    const {
      left,
      width
    } = this.shadowRoot.querySelector('.bar_container').getBoundingClientRect();
    const normalized = positionX - left;
    let percentage = this.map(normalized, 0, width, 0, 1);

    if (percentage < 0) {
      percentage = 0;
    }

    if (percentage > 1) {
      percentage = 1;
    }

    const index = Math.round((this._valueSet.length - 1) * percentage);
    const value = this._valueSet[index];
    return value;
  }

  /**
   * @override
   */
  updateValueAndEmit(value, emitInput, emitChange) {
    const newValue = this._findClosestValue(value); // The input event is processed first, so we need to store whether the
    // value has changed in order to be able to retrieve that information
    // when the change event is processed later on.


    this._valueHasChanged = this._value[0] !== newValue || this._valueHasChanged;
    this.value = newValue;

    if (emitInput) {
      this.input.emit(this.value);
    }

    if (emitChange && this._valueHasChanged) {
      this._valueHasChanged = false;
      this.change.emit(this.value);
    }
  }
  /**
   * @override
   */


  updateKnobSelectionTo(id) {
    super.updateKnobSelectionTo(id);
    this.removeCurrentKnobClass('focused');

    if (id !== undefined) {
      this.lastPickedKnob = parseInt(id, 0);
    }

    this.addCurrentKnobClass('focused');
  }

  _updateKnobPositions() {
    if (this._valueSet.length <= 1) {
      this.knobPositions = [50]; // set the knob to the center of the slider
    } else {
      const index = this._valueSet.indexOf(this.value);

      if (index === -1) {
        throw new Error(`cannot update knob position for value not present in value set; value=${this.value}, value-set=[${this._valueSet}]`);
      }

      this.knobPositions = [this.map(index, 0, this._valueSet.length - 1, 0, 100)];
    }
  }

  render() {
    return html`
     ${this.showValueField ? html`
        <div class="slider-wrapper" tabindex="-1">
          ${this.renderSliderElement()}
          <div class="value-fields">
            ${this._renderFlexiSliderValueField(this._value[0])}
          </div>
        </div>
        ` : html`${this.renderSliderElement()}`}
    `;
  }
  /**
   * Displays a value field next to the slider of needed.
   * @param value - the value of the slider
   */


  _renderFlexiSliderValueField(value) {
    return html`<davinci-numeric-field
      class="value-field"
      id="${'NumericField_0'}"
      type="bare"
      .value=${value}
      .min=${this.min}
      .max=${this.max}
      @change=${e => this.synchronizeValueFieldValue(0, value, [e.detail])}
    ></davinci-numeric-field>`;
  }
  /**
   * @override
   */


  displayLegend() {
    const spaceBetweenLegendValues = 100 / (this._valueSet.length - 1);
    return html`
      <div class ="legend">
        <div class ="verticalLines">
        ${this._valueSet.map(() => html`<div class="verticalLine"></div>`)}
        </div>
        <div class ="values">
        ${this._valueSet.map((value, index) => html`
          <div class="value" style="max-width:${spaceBetweenLegendValues}%; left:${index * spaceBetweenLegendValues}%">${value}${this.unit}</div>
        `)}
        </div>
      </div>
    `;
  }
  /**
   * Returns the element of {@link valueSet} that is closest to the given input or 0 if the {@link valueSet} is empty.
   */


  _findClosestValue(input) {
    if (this._isValueSetEmpty()) {
      return 0;
    }

    if (input === undefined) {
      return this.min;
    }

    let distance = Number.POSITIVE_INFINITY;
    let index = 0;

    for (; index < this._valueSet.length; index++) {
      const currentDistance = Math.abs(this._valueSet[index] - input);

      if (currentDistance < distance) {
        distance = currentDistance;
      } else {
        break;
      }
    } // TODO: the FlexiSlider should not consider ticks


    const roundedIndex = this._roundIndexWithTicks(index - 1);

    return this._valueSet[roundedIndex];
  }
  /**
   * Calls {@link roundWithTicks} with the given index and ensures that a valid index is returned.
   * @private
   */


  _roundIndexWithTicks(index) {
    // Ticks do not work well with the FlexSlider. They should probably be ignored.
    // At least the behavior might come as a surprise to the user.
    let roundedIndex = this.roundWithTicks(index);

    if (roundedIndex >= this._valueSet.length) {
      roundedIndex = this._valueSet.length - 1;
    }

    if (roundedIndex < 0) {
      roundedIndex = 0;
    }

    return roundedIndex;
  }
  /**
   * Sorts the {@link valueSet} and removes duplicates
   */


  _updateValueSet() {
    this._valueSet = [...new Set(this._valueSet)];

    this._valueSet.sort((n1, n2) => n1 - n2);
  }
  /**
   * @override
   */


  updateSyncedState() {
    this._updateValueSet();

    this.value = this._findClosestValue(this.value);
    const min = this.min;
    const max = this.max;

    if (this.value > max) {
      this.value = max;
    }

    if (this.value < min) {
      this.value = min;
    }

    this._updateKnobPositions();
  }

}, (_applyDecoratedDescriptor(_class2.prototype, "valueSet", [_dec2, _dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "valueSet"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "value", [_dec4, _dec5], Object.getOwnPropertyDescriptor(_class2.prototype, "value"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "max", [_dec6, _dec7], Object.getOwnPropertyDescriptor(_class2.prototype, "max"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "min", [_dec8, _dec9], Object.getOwnPropertyDescriptor(_class2.prototype, "min"), _class2.prototype), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "change", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "input", [_dec12, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
